import { useState } from "react";
import { useTranslation } from "react-i18next";
import { SkillsModal } from "./SkillsModal";

export const Skils = ({ skillsData, fetchData, isCurrentUserProfile }) => {
  const { t } = useTranslation();

  const [skilsModal, setSkillsModal] = useState(false);

  const toggleSkillsModal = () => {
    setSkillsModal((prev) => !prev);
  };

  return (
    <>
      <div className="p-4 rounded-lg border border-grey-200 bg-white d-flex flex-column gap-0">
        <div className="d-flex flex-wrap justify-content-between align-items-center column-gap-3 row-gap-2 mb-3">
          <h4 className="mb-0 text-md font-semibold text-grey-800">
            {t("auth.viewProfile.skills")}
          </h4>
          {isCurrentUserProfile && (
            <div className="d-flex align-items-center gap-1">
              <button
                type="button"
                className="text-md text-grey-600 text-decoration-none btn btn-link w-8 h-8 d-flex justify-content-center align-items-center"
                onClick={toggleSkillsModal}
              >
                <i className="bx bx-pencil"></i>
              </button>
            </div>
          )}
        </div>
        <ul className="list-unstyled mb-0 d-inline-flex flex-wrap gap-1">
          {skillsData && skillsData.length > 0 ? (
            skillsData.map((skill, index) => (
              <li key={index.toString()}>
                <span className="d-inline-block px-3 py-1-5 text-xs font-medium text-primary-900 rounded-lg bg-primary-50">
                  {skill.name}
                </span>
              </li>
            ))
          ) : (
            <li>
              <div className="">
                <span className="text-grey-400">
                  {t("auth.viewProfile.noRecognitionAndOutreach")}
                </span>
              </div>
            </li>
          )}
        </ul>
      </div>

      {skilsModal && (
        <SkillsModal
          show={skilsModal}
          skillsData={skillsData}
          toggle={toggleSkillsModal}
          fetchData={fetchData}
        />
      )}
    </>
  );
};
